import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import DashboardPage from "./dashboard/DashboardPage";
import { LayoutSplashScreen } from "../../../_metronic";

const TarifaPage = lazy(() => import("./tarifa/TarifaPage"));
const TarifaCancelamentoPage = lazy(() => import("./tarifa-cancelamento/TarifaCancelamentoPage"));
const TarifaComissaoPage = lazy(() => import("./tarifa-comissao/TarifaComissaoPage"));
const AdminPage = lazy(() => import("./admin/AdminPage"));
const GrupoPage = lazy(() => import("./grupo/GrupoPage"));
const EmpresaPage = lazy(() => import("./empresas/EmpresaPage"));
const MotoristaPage = lazy(() => import("./motorista/MotoristaPage"));
const VeiculoPage = lazy(() => import("./veiculo/VeiculoPage"));
const ViagemPage = lazy(() => import("./viagem/ViagemPage"));
const PagamentoPage = lazy(() => import("./pagamento/PagamentoPage"));
const RelatorioPage = lazy(() => import("./relatorio/RelatorioPage"));
const AgendaVeiculosPage = lazy(() => import("./agenda-veiculos/AgendaVeiculosPage"));

export default function HomePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect exact from="/" to="/dashboard" />

        <Route path="/dashboard" component={DashboardPage} />
        <Route path="/relatorio" component={RelatorioPage} />
        <Route path="/cliente" component={EmpresaPage} />
        <Route path="/motorista" component={MotoristaPage} />
        <Route path="/veiculo" component={VeiculoPage} />
        <Route path="/agenda-veiculo" component={AgendaVeiculosPage} />
        <Route path="/viagem" component={ViagemPage} />
        <Route path="/pagamento" component={PagamentoPage} />
        <Route path="/tarifa" component={TarifaPage} />
        <Route path="/cancelamento" component={TarifaCancelamentoPage} />
        <Route path="/comissao" component={TarifaComissaoPage} />
        <Route path="/admin" component={AdminPage} />
        <Route path="/grupo" component={GrupoPage} />

        <Redirect to="/error/error-v6" />
      </Switch>
    </Suspense>
  );
}
